<div id="modal">
    <div class="title flex gap_10 f_align_c">
        {{'signature' | translate}}
    </div>
    <svg #signSvg mat-dialog-content></svg>
    <div mat-dialog-actions>
        <app-button size="xsm" class="fullwidth" mat-button (click)="onResetClick()">{{'global.reset' |
            translate}}</app-button>
        <app-button size="xsm" class="fullwidth" mat-button (click)="onCancelClick()">{{'global.cancel' |
            translate}}</app-button>
        <app-button size="xsm" class="fullwidth" mat-button (click)="onValidateClick()">{{'global.validate' |
            translate}}</app-button>
    </div>
</div>
